import _assign from "object-assign";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { Input } from '@jpmuitk/input';
import { withStyles } from '@jpmuitk/theme';
import { useControlled } from '@jpmuitk/utils';
import PropTypes from 'prop-types';
import { useRifm } from 'rifm';
import InputWithMask from './internal/InputWithMask';
import { style } from './style';

var defaultFormatter = function defaultFormatter(string) {
  return string;
};

var defaultRifmOptions = {};
var FormattedInput = /*#__PURE__*/forwardRef(function FormattedInput(props, ref) {
  var _props$classes = props.classes,
      inputWrapper = _props$classes.inputWrapper,
      maskClass = _props$classes.mask,
      otherClasses = _objectWithoutProperties(_props$classes, ["inputWrapper", "mask"]),
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
      inputProps = props.inputProps,
      mask = props.mask,
      onChange = props.onChange,
      _props$rifmOptions = props.rifmOptions,
      rifmOptions = _props$rifmOptions === void 0 ? defaultRifmOptions : _props$rifmOptions,
      valueProp = props.value,
      textAlign = props.textAlign,
      other = _objectWithoutProperties(props, ["classes", "defaultValue", "inputProps", "mask", "onChange", "rifmOptions", "value", "textAlign"]);

  var _useControlled = useControlled({
    "default": defaultValue,
    controlled: valueProp,
    name: 'FormattedInput',
    state: 'value'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      valueState = _useControlled2[0],
      setValueState = _useControlled2[1];

  var handleChange = function handleChange(value) {
    setValueState(value);
    onChange && onChange(value);
  };

  var rifmMask = false;

  if (rifmOptions.mask) {
    rifmMask = typeof rifmOptions.mask === 'function' ? rifmOptions.mask(valueState) : rifmOptions.mask;
  }

  var rifm = useRifm(_assign({
    format: defaultFormatter,
    accept: /.*/
  }, rifmOptions, {
    mask: rifmMask,
    value: valueState,
    onChange: handleChange
  }));
  return /*#__PURE__*/React.createElement(Input, _assign({
    classes: otherClasses,
    inputComponent: InputWithMask,
    inputProps: _assign({
      classes: {
        inputWrapper: inputWrapper,
        mask: maskClass
      },
      mask: mask,
      textAlign: textAlign
    }, inputProps),
    onChange: rifm.onChange,
    textAlign: textAlign,
    value: rifm.value
  }, other, {
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? FormattedInput.propTypes = {
  /**
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * @external - material-ui
   * The default input value, useful when not controlling the component.
   */
  defaultValue: PropTypes.string,

  /**
   * @external - material-ui
   * Properties applied to the input element.
   */
  inputProps: PropTypes.objectOf(PropTypes.any),

  /**
   * The mask to display.
   */
  mask: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {string} value The new input value.
   */
  onChange: PropTypes.func,

  /**
   * Options passed to rifm - https://github.com/realadvisor/rifm#input-props.
   */
  rifmOptions: PropTypes.objectOf(PropTypes.any),

  /**
   *
   * Determines the alignment of the input text.
   */
  textAlign: PropTypes.oneOf(['left', 'right']),

  /**
   * @external - material-ui
   * The input value, required for a controlled component.
   */
  value: PropTypes.string
} : void 0;
export default withStyles(style, {
  name: 'FormattedInput'
})(FormattedInput);